export default __webpack_public_path__ + "static/media/P308.4.6969da8f.mp3";